import * as React from "react";
import { SVGProps } from "react";
const SvgSmartphone = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 3h-8C9.8 3 8 4.8 8 7v18c0 2.2 1.8 4 4 4h8c2.2 0 4-1.8 4-4V7c0-2.2-1.8-4-4-4Zm2 22c0 1.1-.9 2-2 2h-8c-1.1 0-2-.9-2-2v-3h12v3Zm0-5H10V7c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v13Zm-6 6c.8 0 1.5-.7 1.5-1.5S16.8 23 16 23s-1.5.7-1.5 1.5.7 1.5 1.5 1.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSmartphone;
